import { IMediaModel } from '@common/models/Media';

export const downloadBlob = (blob: Blob, name: string) => {
	const link = document.createElement('a');
	const url = window.URL.createObjectURL(blob);
	link.href = url;
	link.download = name;

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};

export const downloadFilebyMedia = async (media: IMediaModel) => {
	const response = await fetch(media.url);
	const blob = await response.blob();
	const link = document.createElement('a');
	const url = window.URL.createObjectURL(blob);
	link.href = url;

	if (media.original_name) {
		link.download = media.original_name;
	}

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};

export const downloadFileByUrl = async (file_url: string, name?: string) => {
	const response = await fetch(file_url);
	if (!response.ok) throw new Error('Unable to download file');
	const blob = await response.blob();
	const link = document.createElement('a');
	const url = window.URL.createObjectURL(blob);
	link.href = url;

	link.download = name || file_url?.split('/').pop();

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};
